import { api } from './api';

// Types
export interface FAQ {
  _id: string;
  question: string;
  answer: string;
  category?: string;
  order: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GetFAQsParams {
  page?: number;
  limit?: number;
  category?: string;
  isActive?: boolean;
}

export interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface GetFAQsResponse {
  faqs: FAQ[];
  pagination: PaginationInfo;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

// FAQ Service
export const faqService = {
  // Get FAQs with pagination and filters (public endpoint)
  async getFAQs(params: GetFAQsParams = {}): Promise<ApiResponse<GetFAQsResponse | FAQ[]>> {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.limit) queryParams.append('limit', params.limit.toString());
      if (params.category) queryParams.append('category', params.category);
      // Only fetch active FAQs for public frontend
      queryParams.append('isActive', 'true');

      const url = `/faq${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching FAQs:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch FAQs');
    }
  },

  // Get FAQ by ID (public endpoint)
  async getFAQById(id: string): Promise<ApiResponse<FAQ>> {
    try {
      const response = await api.get(`/faq/${id}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching FAQ:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch FAQ');
    }
  },
};



